import type { TFunction } from 'i18next';
import type { RunInstrument } from '../hooks/useRunInstruments';

export type InstrumentStateChip = {
  label: string;
  color: 'success' | 'error' | 'info' | 'default';
};

export const getInstrumentStateChip = (
  instrument: RunInstrument,
  t: TFunction
): InstrumentStateChip => {
  const points = instrument.measurementCount;
  switch (instrument.runState) {
    case 'completed':
      if (instrument.passFail === 'PASS' || instrument.passFail === 'FAIL') {
        return {
          label: `${instrument.passFail} · ${points} pt${points === 1 ? '' : 's'}`,
          color: instrument.passFail === 'PASS' ? 'success' : 'error'
        };
      }
      return {
        label: t('runPage.ranPoints', {
          defaultValue: 'Ran · {{count}} pts',
          count: points
        }),
        color: 'success'
      };
    case 'failed':
      return {
        label: t('runPage.stateFailed', { defaultValue: 'Failed' }),
        color: 'error'
      };
    case 'aborted':
      return {
        label: t('runPage.stateAborted', { defaultValue: 'Aborted' }),
        color: 'error'
      };
    case 'running':
      return {
        label: t('runPage.stateRunning', { defaultValue: 'Running' }),
        color: 'info'
      };
    case 'pending':
      return {
        label: t('runPage.statePending', { defaultValue: 'Pending' }),
        color: 'info'
      };
    default:
      return {
        label: t('runPage.stateNever', { defaultValue: 'Not calibrated' }),
        color: 'default'
      };
  }
};
